import React from 'react';
import { Link } from 'react-router-dom';
import { LazyLoadImage } from 'react-lazy-load-image-component';

//Import Custom Compoenet
import useViewport from '../useViewport';

function ProductTypeOne(props) {
  const { isImageLoad = true } = props;
  const { width } = useViewport();
  const breakpoint = 992;

  let { addClass = "", product} = props;

  return (
    <div className={`product-default ${addClass}`} style={props.style}>
      <figure>
        {
          isImageLoad ?
            <Link to={`${process.env.PUBLIC_URL}/produkty/${product.category.category_slug}/${product.variants.length > 0 ? product.variants.slice(0, 1).map(variant => variant.product_variant_slug) : product.product_slug}`}>
              <div className="lazy-overlay bg-3"></div>

              {
                product.images.slice(0, 1).map(image => (
                  <LazyLoadImage
                    key={image.product_image_id}
                    alt={product.product_name}
                    src={'https://d22u7e6casvzfe.cloudfront.net/uploads/products/320x320/' + image.product_image}
                    threshold={500}
                    effect="black and white"
                  />
                ))
              }
              {
                width > breakpoint ?
                  product.images.length >= 2 ?
                    product.images.slice(1, 2).map(image => (
                      <LazyLoadImage
                        key={image.product_image_id}
                        alt={product.product_name}
                        src={'https://d22u7e6casvzfe.cloudfront.net/uploads/products/320x320/' + image.product_image}
                        threshold={500}
                        effect="black and white"
                        wrapperClassName="product-image-hover"
                      />
                    ))
                  : null
                : null
              }
            </Link>
          : null
        }

        {/* <div className="label-group">
          {
            product.discount && product.salePrice ?
              <span className="product-label label-sale">PROMOCJA</span>
              <span className="product-label label-sale">{product.discount}%</span>
              : ""
          }
          {
            !product.salePrice && product.featured ?
              <span className="product-label label-hot">hot</span>
              : ""
          }
          {
            !product.salePrice && product.new ?
              <span className="product-label label-new">nowy</span>
              : ""
          }
        </div> */}

        {/* <div className="btn-icon-group">
          <button className="btn-icon btn-add-cart" title="Dodaj do koszyka" data-toggle="modal" data-target="#addCartModal" onClick={() => addToCart(product, 1)}>
            <i className="icon-bag"></i>
          </button>
        </div>
        <Link to="#" className="btn-quickview" title="Szybki podgląd" onClick={(e) => { e.preventDefault(); showQuickView(product) }}>Szybki podgląd</Link> */}
      </figure>
      <div className="product-details">
        <h3 className="product-title" style={{fontWeight: '600'}}>
          <Link to={`${process.env.PUBLIC_URL}/produkty/${product.category.category_slug}/${product.variants.length > 0 ? product.variants.find(variant => variant.product_variant_order === 50) ? product.variants.find(variant => variant.product_variant_order === 50).product_variant_slug : product.variants.find(variant => variant.product_variant_active).product_variant_slug : product.product_slug}`}>{product.product_name}</Link>
        </h3>
        <div className="category-wrap">
          <div className="category-list">
            <Link to={`${process.env.PUBLIC_URL}/produkty/${product.category.category_slug}`} className="product-category">{product.category.category_name}</Link>
          </div>
          {/* <Link to={`${process.env.PUBLIC_URL}/ulubione`} className={`btn-icon-wish ${isInWishlist ? "checked" : ""} ${hasWishIcon ? "" : "d-none"}`} onClick={onWishlistClick} title={`${isInWishlist === true ? "Idź do ulubionych" : "Dodaj do ulubionych"}`}>
            <i className="icon-heart"></i>
          </Link> */}
        </div>
        {/* {
          isRating ?
            <Link to={`${process.env.PUBLIC_URL}/produkty/${category}/${product.product_slug}`} style={{ overflow: 'visible' }}>
              <div className="ratings-container">
                <div className="product-ratings">
                  <span className="ratings" style={{ width: 20 * product.rating + '%' }}></span>
                  <span className="tooltiptext tooltip-top">{product.rating.toFixed(2)}</span>
                </div>
              </div>
            </Link>
            : ""
        }
        {
          product.variants ?
            <div className="price-box">
              <span className="product-price">{priceMin.toFixed(2)} zł - {priceMax.toFixed(2)} zł</span>
            </div>
            :
            product.salePrice ?
              <div className="price-box">
                <span className="old-price">{product.price.toFixed(2)} zł</span>
                <span className="product-price">{product.salePrice.toFixed(2)} zł</span>
              </div>
              :
              <div className="price-box">
                <span className="product-price">{product.price.toFixed(2)} zł</span>
              </div>
        } */}
      </div>
    </div>
  );
}

export default ProductTypeOne;